import type {
	OrderDetailResponseDto,
	PartnerReviewResponseDto,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { CreateReviewForm } from "Order/Components/Form/CreateReviewForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import type { FC } from "react";

const partnerReviewResource = Resources.base.order.partnerReviewForm;

type OrderReviewWidgetProps = {
	order: OrderDetailResponseDto;
	reviews?: PartnerReviewResponseDto[];
};

export const OrderReviewWidget: FC<OrderReviewWidgetProps> = ({
	order,
	reviews,
}) => {
	const { t } = useResource();
	const reviewedPartnerIds = reviews?.map((review) => review.partnerId) ?? [];

	return (
		<BaseCard title={t(partnerReviewResource.addReview)}>
			{order && (
				<CreateReviewForm
					order={order}
					reviewedPartnerIds={reviewedPartnerIds}
				/>
			)}
		</BaseCard>
	);
};
